module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/Groupe 47-6edb1411ab3498fc1d443ea3d8913a0c.png";